// Zdieľaný „popis v ráme" — rovnaký vzhľad popisu v detaile NÁVYKU aj VÝZVY/SÚŤAŽE.
// Text = .bz-aitext (čitateľný tmavý), rám = .bz-descrbox (jemné pozadie + orámovanie).
export function DescrBox({ text, style, className = "" }) {
  if (!text) return null;
  return <div className={`bz-aitext bz-descrbox ${className}`.trim()} style={style}>{text}</div>;
}
